import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import mssignEndpoints from '../../environments/endpoints/mssign-endpoints';
import { environment } from '../../environments/environment';
import {
  CreateAgreementTerm,
  CreateAgreementTermOutput
} from '../models/agreementTerm/createAgreementTerm';
import {
  SignAgreementTerm,
  SignAgreementTermOutput
} from '../models/agreementTerm/signAgreementTerm';
import { SignTermUrl, SignTermUrlOutput } from '../models/agreementTerm/signTermUrl';

@Injectable()
export class MssignService {
  constructor(protected http: HttpClient) {}

  createAgreementTerm: CreateAgreementTerm = (input) => {
    const url = `${environment.apiCadastroSettings.url}/${mssignEndpoints.createAgreementTerm}`;
    return this.http.post<CreateAgreementTermOutput>(url, input);
  }

  signAgreementTerm: SignAgreementTerm = (input) => {
    const url = `${environment.apiCadastroSettings.url}/${mssignEndpoints.signAgreementTerm}`;
    return this.http.post<SignAgreementTermOutput>(url, input);
  }

  signTermUrl: SignTermUrl = (input) => {
    const url = `${environment.apiCadastroSettings.url}/${mssignEndpoints.signTermUrl}`;
    return this.http.post<SignTermUrlOutput>(url, input);
  }
}
